import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { VacancyDataEditForm } from '../components/vacancies/VacancyDataEditForm';
import { useVacancyStore } from '../store/vacancyStore';
import { useRecruiterState } from '../utils/recruiterStateManager';

export default function EditVacancyPage() {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const { setSelectedVacancyById, refreshSelectedVacancy } = useVacancyStore();
  const { refreshVacancies } = useRecruiterState();

  const vacancyId = id ? parseInt(id, 10) : null;

  const handleBack = () => {
    navigate(`/recruiter/vacancy/${vacancyId}`);
  };

  const handleVacancyUpdated = async (updatedVacancyId: number) => {
    console.log('EditVacancyPage: Вакансия обновлена с ID:', updatedVacancyId);

    await refreshVacancies();

    setSelectedVacancyById(updatedVacancyId);
    
    await refreshSelectedVacancy();

    navigate('/recruiter/vacancy');
  };

  if (!vacancyId) {
    return (
      <div className="bg-[#e9eae2] h-full flex items-center justify-center">
        <div className="text-[var(--text-dark)] text-[16px]">
          Неверный ID вакансии
        </div>
      </div>
    );
  }

  return (
    <VacancyDataEditForm
      vacancyId={vacancyId}
      onBack={handleBack}
      onSaveSuccess={handleVacancyUpdated}
    />
  );
}
